import { SessionAPI } from './api/index.ts';

export const session = SessionAPI.getInstance();
